import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import QuickNavSection from "./components/QuickNavSection";
import FeaturedCategories from "./components/FeaturedCategories";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "kaiyun.con 官方导航",
  url: "https://kaiyun.con",
  description: "kaiyun.con 是开云平台的第三方导航入口网站，为用户提供开云平台的官方地址导航、注册登录指引、使用教程以及常见问题解答等服务。",
  contactPoint: {
    "@type": "ContactPoint",
    email: "contact@kaiyun.con",
    contactType: "customer service",
  },
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "kaiyun.con 官方导航",
  url: "https://kaiyun.con",
  description: "kaiyun.con 是您寻找开云平台的重要参考入口，提供导航、注册登录指引及常见问题解答。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://kaiyun.con/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const webpageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "kaiyun.con 官方入口 · 快速直达 - 开云平台导航门户",
  url: "https://kaiyun.con",
  description: "kaiyun.con 是您寻找开云平台的重要参考入口，本页汇聚 kaiyun.con 相关导航、注册登录指引及常见问题解答。",
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="kaiyun.con 官方入口 · 快速直达 - 开云平台导航门户"
        description="kaiyun.con 是您寻找开云平台的重要参考入口，本页汇聚 kaiyun.con 相关导航、注册登录指引及常见问题解答，帮助用户快速定位、安全访问，节省查找时间，立即了解 kaiyun.con 全部功能与服务详情。"
        keywords="kaiyun.con,kaiyun.con官网入口,kaiyun.con注册登录,kaiyun.con网址导航,kaiyun.con使用指南,开云平台入口,kaiyun官方地址"
        canonicalUrl="https://kaiyun.con"
        ogType="website"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <QuickNavSection />
          <FeaturedCategories />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}